import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { DepositStateType } from "types/deposit";

import { extraReducers } from "./deposit.extraReducers";

export const initialState: DepositStateType = {
  isLoading: false,
  isLoadingDeposit: false,
  dataDeposit: {
    bank: [],
    player_bank: [],
    currencies: [],
    offline_banking_channel: [],
    online_banking_channel: [],
    promotion: [],
    setting: {
      min_deposit: 0,
      max_deposit: 0,
    },
  },
  dataWithdrawal: {
    player_bank: [],
    currencies: [],
    setting: {
      min_withdrawal: 0,
      max_withdrawal: 0,
    },
  },
  dataMemberOrder: {
    totalCount: 0,
    totalPages: 0,
    pageSize: 10,
    currentPage: 1,
    data: [],
  },
};

const depositSlice = createSlice({
  name: "bank",
  initialState,
  reducers: {
    resetDeposit: () => initialState,
  },
  extraReducers,
});

export const selectDataDeposit = (state: ApplicationRootState) =>
  state.deposit.dataDeposit;

export const selectDataMemberOrder = (state: ApplicationRootState) =>
  state.deposit.dataMemberOrder;

export const selectIsLoading = (state: ApplicationRootState) =>
  state.deposit.isLoading;

export const selectDataWithdrawal = (state: ApplicationRootState) =>
  state.deposit.dataWithdrawal;

export const selectIsLoadingDeposit = (state: ApplicationRootState) =>
  state.deposit.isLoadingDeposit;

export const { resetDeposit } = depositSlice.actions;

export default depositSlice.reducer;
